import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { MyHrShellSummary } from './my-hr-workspace.models';

interface MyHrNavItem {
  label: string;
  route: string;
  icon: string;
  badge?: number;
  visible: boolean;
}

@Component({
  selector: 'app-my-hr-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TagModule],
  templateUrl: './my-hr-nav.component.html',
  styleUrls: ['./my-hr-nav.component.scss']
})
export class MyHrNavComponent {
  @Input() summary?: MyHrShellSummary;
  @Input() canViewManager = false;
  @Input() canViewExpenses = false;
  @Input() canManageExpenses = false;
  @Input() canApproveExpenses = false;

  get items(): MyHrNavItem[] {
    return [
      { label: 'Home', route: '/my-hr', icon: 'fa-solid fa-house', visible: true },
      { label: 'Profile', route: '/my-hr/profile', icon: 'fa-solid fa-id-badge', visible: true },
      { label: 'Documents', route: '/my-hr/documents', icon: 'fa-solid fa-folder-open', badge: this.summary?.documentsCount, visible: true },
      { label: 'Leave', route: '/my-hr/leave', icon: 'fa-solid fa-calendar-day', badge: this.summary?.pendingLeaveCount || this.summary?.leaveCount, visible: true },
      { label: 'Timesheets', route: '/my-hr/timesheets', icon: 'fa-solid fa-clock', badge: this.summary?.timesheetCount, visible: true },
      { label: 'Payslips', route: '/my-hr/payslips', icon: 'fa-solid fa-wallet', badge: this.summary?.payslipCount, visible: true },
      { label: 'Learning', route: '/my-hr/learning', icon: 'fa-solid fa-graduation-cap', badge: this.summary?.learningCount, visible: true },
      { label: 'Expenses', route: '/my-hr/expenses', icon: 'fa-solid fa-receipt', badge: this.summary?.expenseCount, visible: this.canViewExpenses || this.canManageExpenses },
      { label: 'Approvals', route: '/my-hr/approvals', icon: 'fa-solid fa-clipboard-check', badge: (this.summary?.approvalsCount || 0) + (this.summary?.pendingExpenseApprovals || 0), visible: true },
      { label: 'Team', route: '/my-hr/team', icon: 'fa-solid fa-people-group', badge: this.summary?.teamCount, visible: this.canViewManager }
    ].filter(item => item.visible);
  }
}
